import React, { SyntheticEvent, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Checkbox, FormField, Header, Icon, Modal, ModalActions, ModalContent, Popup } from 'semantic-ui-react';
import { updateOrderStatusToReceivedInStore } from '../../../services/orders.service';
import Order from '../../../types/entities/Order';
import { useAppContext } from '../../../hooks/AppProvider';
import { useAuth } from '../../../hooks/AuthProvider';
import { USER_ROLE_ADMINISTRATOR } from '../../../utils/constants';

interface Props {
    id: string | undefined;
    setOrder: (order: Order) => void;
    disabled?: boolean
}

const UpdateStatusToReceivedInStoreModal = (props: Props) => {

    const { updateParentState } = useAppContext();
    const { userData } = useAuth();
    const isSuperAdmin = userData?.role === USER_ROLE_ADMINISTRATOR;

    const [ openModal, setOpenModal ] = useState(false);
    const [ confirmChecked, setConfirmChecked ] = useState(false);
    const [ sendNotification, setSendNotification ] = useState(true);

    const handleOpenModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    const handleReadyToSchedule = async (event: SyntheticEvent, orderId: string | undefined, sendNotification: boolean) => {
        event.preventDefault();
        updateParentState({ loading: true });
        try {

            if (orderId === undefined) {
                throw new Error("El id del pedido no puede ser undefined.");
            }

            const response = await updateOrderStatusToReceivedInStore(orderId, sendNotification);
            if (response?.status === 200) {
                props.setOrder(response?.data);
                toast.success("El pedido ha sido movido a listo para agendar exitosamente.");
                setOpenModal(false);
            } else {
                throw new Error( "Ha ocurrido un error al mover el pedido a listo para agendar.");
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            updateParentState({ loading: false });
        }
    };

    return (
        <>   
            <Modal
                closeOnDimmerClick
                closeIcon={true}
                size="small"
                onClose={(event) => handleCancelModal(event)}
                open={openModal}
                trigger={
                    <Popup
                        trigger={
                            <Button color="green" floated='right' icon 
                                disabled={props.disabled}
                                onClick={ (event) => handleOpenModal(event) } >
                                Mover pedido a "Recibido en almacen"
                            </Button>
                        }
                        content='Mover pedido a "Recibido en almacen"'
                        position='top center'
                        size='small'
                        inverted
                    />
                } >
                <Header icon="check square" content='Mover pedido a "Recibido en almacen"' />
                <ModalContent>
                    <p>
                        Recuerda que una vez que modifiques el estatus ya no se podra regresar al estatus
                        anterior (este movimiento no envia mensaje al cliente).
                    </p>

                    <div className="ui form">
                        <FormField>
                            <Checkbox 
                                toggle
                                disabled={!isSuperAdmin}
                                checked={sendNotification}
                                label='Enviar notificación de whatsapp'
                                onChange={ (event, data) => setSendNotification(sendNotification ? false : true) }
                            />
                        </FormField>
                        <FormField>
                            <Checkbox
                                toggle
                                label="Confirmo que quiero actualizar el estatus del pedido."
                                checked={confirmChecked}
                                onChange={ (event, data) => setConfirmChecked(confirmChecked ? false : true) }
                            />
                        </FormField>
                    </div>
                </ModalContent>
                <ModalActions>
                    <Button onClick={ (event) => handleCancelModal(event) }>
                        <Icon name="cancel" /> Cancelar
                    </Button>
                    <Button color="green" onClick={ (event) => handleReadyToSchedule(event, props.id, sendNotification) } disabled={!confirmChecked}>
                        <Icon name="checkmark" /> Aceptar
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
};

export default UpdateStatusToReceivedInStoreModal;
